export default {
  methods: {
    toastNotification(msg, options) {
        return this.$bvToast.toast(msg, options);
    },
    quickToast(title, msg, variant) {
        return this.toastNotification(msg, {
            title: title,
            variant: variant
        });
    },
    quickSuccessToast(title, msg) {
        return this.quickToast(title, msg, 'success');
    },
    quickDangerToast(title, msg) {
        return this.quickToast(title, msg, 'danger');
    },
    quickWarningToast(title, msg) {
        return this.quickToast(title, msg, 'warning');
    },
    quickInfoToast(title, msg) {
        return this.quickToast(title, msg, 'info');
    },
  }
}